@if (showSection) {
  <div class="container">
    <div class="category-bar layout-row space-between category-section">
      <div class="layout-row">
        <div class="tabs layout-row align-middle">
          @for (item of categories; track item) {
            @if (item.types && item.types.includes('footer')) {
              <div class="tab" [class.active]="router.isActive('/' + (item.slug), false)">
                <a class="btn btn-menu" [href]="'./'+(item.slug)" (click)="navClick(item.name,'category menu desktop')">
                  <div class="layout-row align-middle">
                    <div class="category-icon small-icon">
                      <img [src]="item.marker" [alt]="item.slug" width="16px" height="16px">
                    </div>
                    <span class="spacer-left-8">
                      {{item.name}}
                    </span>
                  </div>
                </a>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
}
